import React, { Component } from "react";
import NavControlsGenerator from "../utilities/NavControlsGenerator";

class ScopeOfService extends Component {
  componentDidMount() {
  }
  render() {
    return (
      <section className="sectionContent"><div className="page">
        <header>
          <h2>Scope of Business</h2>
        </header>
        <div className="pageContent"></div>
        <NavControlsGenerator currentPageNavCode={91}></NavControlsGenerator>
      </div></section>
    );
  }
}

export default ScopeOfService;
